import axiosBackEnd from "../config/axios/axios-back-end";

// Get document from mydocs side
export const getDocsFromMyDocs = async (projectData) => {
  const url = `/api/notificationSchedules/getDocsFromMydocs`;
  const response = await axiosBackEnd.get(url, {
    params: projectData,
  });
  return response.data;
};

// Get Reminder From Reminder API
export const getReminderFromReminderAPI = async (findReminderDataSet) => {
  const url = `/api/notificationSchedules/getReminderFromReminderAPI`;
  const response = await axiosBackEnd.get(url, {
    params: findReminderDataSet,
  });
  return response.data;
};

// Get document from mydocs side
export const getReminderFromMyDocs = async (findReminderDataSet) => {
  const url = `/api/notificationSchedules/getReminderFromMyDocs`;
  const response = await axiosBackEnd.get(url, {
    params: findReminderDataSet,
  });
  return response.data;
};

// Add Reminder On Reminder API
export const addReminderOnReminderAPI = async ({
  findReminderDataSet,
  data,
}) => {
  console.log(findReminderDataSet, data);
  const url = `/api/notificationSchedules/addReminderForReminderAPI`;
  const response = await axiosBackEnd.post(url, data, {
    params: findReminderDataSet,
  });
  return response.data;
};

// Update Reminder On Reminder API
export const updateReminderOnReminderAPI = async ({
  findReminderDataSet,
  data,
}) => {
  const url = `/api/notificationSchedules/updateReminderOnReminderAPI`;
  const response = await axiosBackEnd.put(url, data, {
    params: findReminderDataSet,
  });
  return response.data;
};
// Update Reminder On Mydocs
export const updateReminderOnMyDocs = async ({ findReminderDataSet, data }) => {
  const url = `/api/notificationSchedules/updateReminderMydocs`;

  const response = await axiosBackEnd.put(url, data, {
    params: findReminderDataSet,
  });
  return response.data;
};

export default {
  getDocsFromMyDocs,
  getReminderFromReminderAPI,
  getReminderFromMyDocs,
  addReminderOnReminderAPI,
  updateReminderOnReminderAPI,
  updateReminderOnMyDocs,
};
